<div class="content">
  <div class="tlr-bluetag-container">
    <div class="section-title">Missing Recommended Repair Date</div>

    <div class="table-chart-container mt-10">
      <div class="exportToExcel excel-btn">
        <div class="actions">
          <button pButton type="button" label="Export To Excel" icon="pi pi-file-excel" class="p-button-outlined" (click)="exportToExcel()">Export To Excel</button>
        </div>
      </div>
      <p-table [value]="missingPermanentRepairDate"  [paginator]="true"  [rows]="10" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th>Tag Number</th>
            <th>Entry Date</th>
            <th>Op. User ID</th>
            <th>Division</th>
            <th>Section</th>
            <th>Plant</th>
            <th>LDAR</th>
            <th>Op. PSI</th>
            <th>Op. Temp</th>
            <th>Service</th>
            <th>Insp. User ID</th>
            <th>Service Class</th>
            <th>OA User ID</th>
            <th>Permanent Repair Date</th>
            <th>Eng. User ID</th>
            <th>TLR Type</th>
            <th>Maximo WO Number</th>
            <th>Maximo Outage-T/A</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
          <tr *ngFor="let data of missingPermanentRepairDate">
            <td><a routerLink="/details-section/{{data.Tag_Number}}">
              {{ data.Tag_Number }}</a></td>
            <td>{{data.Data_Entry_Date | date: 'MM/dd/yyyy'}}</td>
            <td class="left-align">{{data.Operator_CAI}}</td>
            <td class="left-align">{{data.Division}}</td> 
            <td class="left-align">{{data.Section}}</td>
            <td class="left-align">{{data.Plant}}</td>
            <td class="left-align">{{data.LDAR}}</td>  
            <td>{{data.Oper_PSI}}</td>         
            <td>{{data.Oper_Temp}}</td>         
            <td class="left-align">{{data.Service}}</td>         
            <td class="left-align">{{data.InspectionCAI}}</td>         
            <td>{{data.ServiceClass}}</td>     
            <td>{{data.OACAI}}</td>    
            <td [ngClass]="commonService.getDateColorClass(data.Permanent_Repair_Date)">{{data.Permanent_Repair_Date}}</td>            
            <td>{{data.EngineeringCAI}}</td>
            <td>{{data.TLRType}}</td>
            <td>{{data.Maximo_WO_Number}}</td>
            <td>{{data.Maximo_Outage_T_A}}</td>


          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
              <td colspan="17">No records found.</td>
          </tr>
      </ng-template>
      </p-table>
    </div>
  </div>
</div>